import ReloadButton, { ReloadHandler } from '../Button/ReloadButton';

export interface TableErrorProps {
  icon?: string;
  reload?: ReloadHandler;
  message?: string;
}

export const TableError = (Props: TableErrorProps) => {
  const {
    icon = 'error',
    message = 'We are unable to retrieve the latest data. Please try again later or contact support if this issue persists.',
    reload,
  } = Props;

  return (
    <td className="flex flex-col items-center max-w-lg text-center">
      <span className="text-8xl material-symbols-outlined dark:text-white">{icon}</span>
      <p className="mb-8 text-xl">{message}</p>
      <ReloadButton text="Reload Page" reload={reload} />
    </td>
  );
};
